module.exports = "https://store.zigzag.kr/resources/arm64/20260305-1549-72d6b8f382_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";